import { graphql } from 'react-relay';

export default graphql`
  query ThisIsATreePage_Query {
    viewer {
      id
      ...ThisIsATreePage_viewer
    }
  }
`;
